<span [class]="'badge badge-' + colorClass">{{
    'payment-state.' + CashPaymentStatus[state] | translate
}}</span>
